"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("../infrastructure");
var browser_api_1 = require("./browser-api");
var openfin_api_1 = require("./openfin-api");
var jet_api_1 = require("./jet-api");
var WindowContainerApiType;
(function (WindowContainerApiType) {
    WindowContainerApiType["JET"] = "JET";
    WindowContainerApiType["OpenFin"] = "OpenFin";
    WindowContainerApiType["Browser"] = "Browser";
})(WindowContainerApiType = exports.WindowContainerApiType || (exports.WindowContainerApiType = {}));
var isInEikonContainer = function () {
    return (typeof window !== "undefined" &&
        (navigator.userAgent.indexOf("Eikon") >= 0 ||
            navigator.userAgent.indexOf("TR-Electron") >= 0 ||
            (typeof window.EikonNow !== "undefined" && window.EikonNow.isEnabled())));
};
exports.windowContainerApi = (function () {
    if (typeof fin !== "undefined") {
        return openfin_api_1.openFinApi;
    }
    else if (isInEikonContainer()) {
        return jet_api_1.jetApi;
    }
    else {
        return browser_api_1.browserApi;
    }
})();
console.log("Using " + exports.windowContainerApi.type + " as a container API");



//////////////////
// WEBPACK FOOTER
// /app/~/redi-window-container-web-lib/dist/business/window-container-api.js
// module id = 38
// module chunks = 0